// User name colors (Twitch style)
export const userColors = [
  "#FF0000", // Red
  "#0000FF", // Blue
  "#00FF00", // Green
  "#B22222", // Dark red
  "#FF7F50", // Coral
  "#9ACD32", // Yellow green
  "#FF4500", // Orange red
  "#2E8B57", // Sea green
  "#DAA520", // Gold
  "#D2691E", // Chocolate
  "#5F9EA0", // Cadet blue
  "#1E90FF", // Dodger blue
  "#FF69B4", // Hot pink
  "#8A2BE2", // Blue violet
  "#00FF7F", // Spring green
];

/**
 * Returns a random color for a username
 * Uses the username as a seed to always get the same color for the same user
 */
export const getUserColor = (username: string): string => {
  if (!username) return userColors[0];
  
  // Create a simple hash from the username
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Use the hash to select a color
  const index = Math.abs(hash) % userColors.length;
  return userColors[index];
};
